// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__189HC","overflowing":"ReadFullNote_overflowing__q3YvZ"};